import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserType } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredUserType: UserType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredUserType }) => {
  const token = localStorage.getItem('accessToken');
  const secret = localStorage.getItem('accessSecret');
  const userType = localStorage.getItem('userType');

  // Require both accessToken AND accessSecret for authentication
  if (!token || !secret) {
    return <Navigate to="/" replace />;
  }

  if (userType !== requiredUserType) {
    // Redirect to appropriate dashboard or login
    if (userType === UserType.Administrator) {
      return <Navigate to="/kivu" replace />;
    } else if (userType === UserType.Merchant) {
      return <Navigate to="/igwena" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

